import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  loadExcelData,
  isDataLoaded,
  getIndustryDistribution,
  getEmployeeDistribution,
  getBillingDistribution,
  getFillRateSales,
  getPerfectSalesOrder,
  getPerfectOrderByEmployees,
  getForecastAccuracy,
  getFillRatePurchases,
  getSupplierDeliveries,
  getInventoryRotation,
  getWarehouseUtilization,
  getWarehouseOutsourcing,
  getTransportOutsourcing,
  getContainerUtilization,
  getTransportDelivery,
  getPersonnelRotation,
  getCarbonMeasurement,
  getCarbonFootprint,
  getPayrollCost,
  getTransportCost,
  getDistributionCost,
  getThreeCosts,
  getDashboardStats,
  getRawSheet
} from '../services/dataLoader';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    async function initData() {
      try {
        console.log('1. Starting Excel load...');
        setLoading(true);
        console.log('2. Calling loadExcelData()...');
        await loadExcelData();
        console.log('3. Excel loaded successfully!');
        setDataReady(true);
        setError(null);
      } catch (err) {
        console.error('ERROR loading Excel:', err);
        setError(err.message);
      } finally {
        console.log('4. Done loading');
        setLoading(false);
      }
    }
    initData();
  }, []);

  const value = {
    loading,
    error,
    dataReady,
    isDataLoaded,
    // Data getters
    getIndustryDistribution,
    getEmployeeDistribution,
    getBillingDistribution,
    getFillRateSales,
    getPerfectSalesOrder,
    getPerfectOrderByEmployees,
    getForecastAccuracy,
    getFillRatePurchases,
    getSupplierDeliveries,
    getInventoryRotation,
    getWarehouseUtilization,
    getWarehouseOutsourcing,
    getTransportOutsourcing,
    getContainerUtilization,
    getTransportDelivery,
    getPersonnelRotation,
    getCarbonMeasurement,
    getCarbonFootprint,
    getPayrollCost,
    getTransportCost,
    getDistributionCost,
    getThreeCosts,
    getDashboardStats,
    getRawSheet
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
}

export default DataContext;
